const UserFacedAPI = {
    getProfile() {
        return Request.get('/admin/userfaced/profile');
    },
    updateProfile(data) {
        return Request.post('/admin/userfaced/updateProfile', data);
    },
    /**
     * 更新密码
     */
    updateMyPwd(data) {
        return Request.post('/admin/userfaced/updateMyPwd', data);
    },
    verifyEmailAddress(st, code) {
        return Request.post('/admin/userfaced/verifyEmailAddress', { st: st, code: code });
    },
    /**
     * 向用户发送邮件验证Email
     * @param {} userId
     */
    sendPwdRestEmailByEmailAddress(emailAddress) {
        return Request.get(`/admin/mail/sendPwdRestEmail`, { email: emailAddress });
    },
    /**
     * 检查手机验证码是否正确
     */
    checkPhoneVerifyCode(phone, verifyCode, type) {
        return Request.post('/admin/userfaced/checkPhoneVerifyCode', { phone: phone, verifyCode: verifyCode, type: type });
    },
    changeUsername(username) {
        return Request.post('/admin/userfaced/changeUsername', { username: username });
    },
    changeUserPhone(data) {
        return Request.post('/admin/userfaced/changeUserPhone', data);
    },
    changeUserPwdByPhone(data) {
        return Request.post('/admin/userfaced/changePwdByPhone', data);
    },
    checkEmailValidate(data) {
        return Request.post('/admin/userfaced/checkEmailValidate', data);
    },
    changePwdByEmail(data) {
        return Request.post('/admin/userfaced/changePwdByEmail', data);
    }
};
export default UserFacedAPI;
